import * as Yup from 'yup';

import { ALLOWED_CHARACTERS_REGEX, MAX_FILE_SIZE_5MB, ROLES } from '@/common/constants';

const checkFileSize = (files?: File[]): boolean  => {
    let totalSize = 0;
    if (files) {
        files.map(file => {
            totalSize += file.size;
        })
    }
    return (totalSize <= MAX_FILE_SIZE_5MB)
};

export const invoiceSireReviewRequestorSchema = (role: string) => (
    Yup.object({
        invoiceID: role === ROLES.FINANCE ?
            Yup.string()
                .trim()
                .required('Invoice Number is required')
                .matches(ALLOWED_CHARACTERS_REGEX, 'Input must only contain alphabets, numbers, commas, dots, slashes, and dashes.')
                .max(50, 'Max length is 50 characters') :
            Yup.string()
                .nullable()
                .trim()
                .matches(ALLOWED_CHARACTERS_REGEX, 'Input must only contain alphabets, numbers, commas, dots, slashes, and dashes.')
                .max(50, 'Max length is 50 characters'),
        invoiceDate: Yup.date().required('Invoice date is required'),
        //reviewCost: Yup.string().required('Cost per review is required').matches(/^(Rp.|\$)[1-9][\d.,]*/, 'Cost per review cannot be zero or negative'),
        reviewCost: Yup.string().required('Cost per review is required'), // temporary fix
        faktur: role === ROLES.FINANCE ?
            Yup.array().required('Invoice file is required').test('fileSize', 'File size is too large', checkFileSize)
            : Yup.array().nullable(),
    })
);
